export enum CommonPriceTypes {
    VK1 = 'VK1',
    VK2 = 'VK2',
}
